var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('div',{attrs:{"id":"events-categoryaxis"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }